
import { Component, Prop, Vue } from 'vue-property-decorator'
import GradientLegend from '@/components/legend/GradientLegend.vue'
import RainGaugesLegend from '@/components/legend/RainGaugesLegend.vue'
import { ISettingService } from '@/services/setting/ISettingService'
import GradientLegendHeader from './GradientLegendHeader.vue'
import GradientLegendHeaderRainfallDropdown from './GradientLegendHeaderRainfallDropdown.vue'
import { Representation, RepresentationTypes } from '@/model/Representation'

@Component({
  components: {
    RainGaugesLegend,
    GradientLegend,
    GradientLegendHeader,
    GradientLegendHeaderRainfallDropdown,
  },
})
export default class Legends extends Vue {
  @Prop() representation!: Representation<RepresentationTypes>
  private hasRainGauges = false
  private settingService!: ISettingService

  created(): void {
    this.settingService = this.$services.get<ISettingService>('setting')
    this.initialize()
  }

  async initialize(): Promise<void> {
    const settings = await this.settingService.getSettings()
    this.hasRainGauges = settings.getHasRainGauges()
  }

  get showRainGaugesLegend(): boolean {
    return this.isRainfallPresentation && this.hasRainGauges
  }

  get isRainfallPresentation(): boolean {
    return this.representation.type === 'rainfall' || this.representation.type === 'cumulative rainfall'
  }
}
